(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-withdrawal-form"]) return;
  try {
    
  (() => {
    const storageKey = 'mb_withdrawal_copy_v2:' + window.location.pathname;
    const form = document.getElementById('MbWithdrawalForm');
    const success = document.getElementById('MbWithdrawalSuccess');
    if (!form) return;

    const collectValues = () => {
      const values = {};
      new FormData(form).forEach((value, name) => {
        if (name.startsWith('contact[')) {
          values[name.slice(8, -1)] = String(value).trim();
        }
      });
      return values;
    };
    const declarationLines = (values) => [
      'Maison Bassano',
      '',
      'Nom et prénom : ' + values['Nom et prénom'],
      'Adresse électronique : ' + values.email,
      'Numéro de commande : ' + values['Numéro de commande'],
      'Date de la commande : ' + (values['Date de la commande'] || 'Non renseignée'),
      'Date de réception : ' + (values['Date de réception'] || 'Non renseignée'),
      'Produit(s) concerné(s) : ' + values['Produit(s) concerné(s)'],
      '',
      'Déclaration : ' + values.body
    ];
    const removeStoredCopy = () => {
      try { sessionStorage.removeItem(storageKey); } catch (error) {}
    };

    if (!success) {
      const review = document.getElementById('MbWithdrawalReview');
      const reviewText = document.getElementById('MbWithdrawalReviewText');
      const fields = document.getElementById('MbWithdrawalFields');
      const confirmation = document.getElementById('MbWithdrawalConfirmation').closest('label');
      const edit = document.getElementById('MbWithdrawalEdit');
      const submit = document.getElementById('MbWithdrawalSubmit');
      let reviewedValues = null;
      removeStoredCopy();
      submit.textContent = 'Vérifier ma déclaration';

      edit.addEventListener('click', () => {
        reviewedValues = null;
        review.hidden = true;
        edit.hidden = true;
        fields.hidden = false;
        confirmation.hidden = false;
        submit.textContent = 'Vérifier ma déclaration';
        document.getElementById('MbWithdrawalName').focus();
      });

      form.addEventListener('submit', (event) => {
        const values = collectValues();
        const serialized = JSON.stringify(values);
        if (reviewedValues !== serialized) {
          event.preventDefault();
          reviewedValues = serialized;
          reviewText.textContent = declarationLines(values).join('\n');
          review.hidden = false;
          edit.hidden = false;
          fields.hidden = true;
          confirmation.hidden = true;
          submit.textContent = 'Confirmer la rétractation';
          review.focus();
          return;
        }
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({
            values,
            preparedAt: new Date().toISOString()
          }));
        } catch (error) {
          removeStoredCopy();
        }
      });
      return;
    }

    let storedCopy = null;
    try { storedCopy = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (error) {}
    removeStoredCopy();
    const values = storedCopy && storedCopy.values;
    const requiredFields = ['Nom et prénom', 'email', 'Numéro de commande', 'Produit(s) concerné(s)', 'body'];
    const hasCompleteCopy = values && typeof values === 'object' && requiredFields.every(
      (name) => typeof values[name] === 'string' && values[name].trim().length > 0
    );
    const preparedAt = storedCopy && typeof storedCopy.preparedAt === 'string' ? new Date(storedCopy.preparedAt) : null;
    if (!hasCompleteCopy || !preparedAt || Number.isNaN(preparedAt.getTime())) {
      success.focus();
      return;
    }

    const dateText = preparedAt.toLocaleString('fr-FR', {
      timeZone: 'Europe/Paris',
      dateStyle: 'long',
      timeStyle: 'medium'
    });
    const copyText = [
      'COPIE DE VOTRE DÉCLARATION DE RÉTRACTATION',
      '',
      ...declarationLines(values),
      '',
      'Date et heure indiquées par votre appareil : ' + dateText + ' (heure de Paris)',
      '',
      'Cette copie reprend les informations saisies. Elle ne constitue pas un accusé de réception émis par Maison Bassano et n’atteste pas de la date ou de l’heure de réception.'
    ].join('\n');
    document.getElementById('MbWithdrawalReceipt').textContent = copyText;
    document.getElementById('MbWithdrawalCopyPanel').hidden = false;
    document.getElementById('MbWithdrawalCopyUnavailable').hidden = true;
    document.getElementById('MbWithdrawalPrint').addEventListener('click', () => window.print());
    document.getElementById('MbWithdrawalDownload').addEventListener('click', () => {
      const blob = new Blob([copyText], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'copie-declaration-retractation-maison-bassano.txt';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    });
    success.focus();
  })();

  } catch(e) { console.error(e); }
})();
})();
